import { App } from '@application'

export default App
